export default function () {
    const triggers = [].slice.call(document.querySelectorAll('[data-toggle="collapse"]'));
    window.addEventListener('click', (ev) => {
        const elm = ev.target;
        if (triggers.includes(elm)) {
            const selector = elm.getAttribute('data-target');
            collapse(selector, 'toggle');
            elm.classList.toggle('collapsed');
        }
    }, false);

    const fnmap = {
        toggle: 'toggle',
        show: 'add',
        hide: 'remove'
    };
    const collapse = (selector, cmd) => {
        const targets = [].slice.call(document.querySelectorAll(selector));
        targets.forEach(target => {
            target.classList[fnmap[cmd]]('show');
        });
    };
};
